import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { checkAccessFn } from "../../../../../../../../../utils/checkAccess";
import { setAppError } from "../../../../../../../../../store/userSlice";

export default function TableNotes({
  titles = ["Sl No.", "Description", "Action"],
  allNotes = [],
  setAllNotes,
}) {
  const dispatch = useDispatch();

  const handleInputChange = (id, value) => {
    const updatedNote = allNotes.map((data) => {
      if (data?.id == id) {
        return { ...data, description: value };
      }
      return data;
    });
    setAllNotes(updatedNote);
  };

  const handleDelete = (id) => {
    if (allNotes.length <= 1) {
      return dispatch(
        setAppError({
          msg: "Atleast one note is needed.",
        })
      );
    }

    setAllNotes((prevState) => prevState.filter((data) => data?.id != id));
  };

  return (
    <>
      <div className="p-5 overflow-x-auto ">
        <div
          className={`grid justify-items-center items-center grid-cols-table-3 auto-cols-min gap-5 p-6 bg-white  w-full min-w-fit  rounded-md `}
        >
          {titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}

          {allNotes.length <= 0 && (
            <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-3">
              <p>Loading</p>
              <CgSpinner className="animate-spin" />
            </div>
          )}
          {allNotes?.map((note, index) => (
            <React.Fragment key={note?.id}>
              <p>{Number(index) + 1}</p>

              <textarea
                rows={2}
                className="textarea textarea-sm textarea-bordered w-full textTransformNone"
                type="text"
                defaultValue={note?.description}
                required
                onChange={(e) =>
                  handleInputChange(note?.id, String(e.target.value))
                }
                placeholder="Enter Description"
              />
              <div className="flex gap-3 min-w-fit ">
                <button
                  type="button"
                  onClick={() => handleDelete(note?.id)}
                  className="p-1 px-2 rounded-md ring-1 ring-slate-300"
                >
                  <MdDeleteOutline size={"1.4rem"} />
                </button>
              </div>

              <hr className="border-[1.5px] border-slate-100  w-full col-span-3" />
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
}
